<script>
  import { writable } from 'svelte/store';
  import { setContext } from 'svelte';
  export let multiple = false;
  const ctx = {
    selected: multiple ? undefined : writable(),
  };
  setContext('ctx', ctx);
</script>

<div class="grid gap-y-4">
  <slot />
</div>
